import { LeverageValues, LeverageResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateLeverage(values: LeverageValues, t?: ToolsTranslations['leverage']): LeverageResult {
  const { securityRequirement, unitCost, numberOfContracts } = values;

  if (securityRequirement <= 0) {
    return { leverage: null, isValid: false, message: t?.invalid.securityRequirement ?? 'Säkerhetskrav måste vara större än 0' };
  }
  if (unitCost <= 0) {
    return { leverage: null, isValid: false, message: t?.invalid.unitCost ?? 'Enhetskostnad måste vara större än 0' };
  }
  if (numberOfContracts <= 0) {
    return { leverage: null, isValid: false, message: t?.invalid.numberOfContracts ?? 'Antal kontrakt måste vara större än 0' };
  }

  const totalPositionValue = unitCost * numberOfContracts;
  const leverage = Math.round((totalPositionValue / securityRequirement) * 100) / 100; // PREC(...,2) - rounds to 2 decimal places
  
  if (!isFinite(leverage)) {
    return { leverage: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }
  
  return { leverage, isValid: true };
}
